// Klaviyo. Fill listId, then verify the request shape against current Klaviyo client API docs
// (https://developers.klaviyo.com/en/reference/create_client_subscription).
// SMS consent + quiz tags go to Attentive (attentiveSubmit below), same as the Digioh quiz.
var KLAVIYO = {
  publicKey: 'LgJpFW', // Klaviyo public API key / company_id (from layout/theme.liquid)
  listId: '',          // Marketing list ID. Theme uses XwiaWg (old quiz form) and HxHGex (site-wide). Confirm with lifecycle team.
  revision: '2024-10-15'
};

// Subscribes email (and phone if given) and stamps quiz_* profile properties.
// Returns a promise. Never throws; quiz must continue even if Klaviyo fails.
function klaviyoSubmit(email, phone, properties) {
  if (!KLAVIYO.publicKey || !KLAVIYO.listId) {
    console.log('[klaviyo placeholder] would send', { email: email, phone: phone, properties: properties });
    return Promise.resolve();
  }
  var attrs = { email: email, properties: properties };
  var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
  if (phone) { attrs.phone_number = phone; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
  var body = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Lip Quiz',
        profile: { data: { type: 'profile', attributes: Object.assign(attrs, { subscriptions: subs }) } }
      },
      relationships: { list: { data: { type: 'list', id: KLAVIYO.listId } } }
    }
  };
  return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO.publicKey, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', revision: KLAVIYO.revision },
    body: JSON.stringify(body)
  }).catch(function (e) { console.warn('klaviyo failed', e); });
}

// Attentive. The storefront tag can only identify, not set attributes, so tags go through the
// server-side proxy (scripts/attentive-quiz-worker.js), which holds the private API key.
function attentiveSubmit(endpoint, email, phone, payload) {
  try { window.attentive.analytics.identify({ email: email }); } catch (e) {}
  if (!endpoint) {
    console.log('[attentive placeholder] would send', Object.assign({ email: email, phone: phone }, payload));
    return;
  }
  // ponytail: text/plain skips the CORS preflight; keepalive lets the request finish after the redirect.
  fetch(endpoint, {
    method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify(Object.assign({ email: email, phone: phone }, payload))
  }).catch(function (e) { console.warn('attentive failed', e); });
}
// GA4 measurement id for thelipbar (same property as the commented gtag snippet in layout/theme.liquid).
// dataLayer {event} pushes stay for GTM. They do not create a collect hit unless the container has a tag.
// This sends the hit directly. send_page_view:false so the quiz page does not add a second page_view.
// ponytail: loader lives on the quiz asset only. If GTM-WFC4368 grows a GA4 Event tag per quiz_* name, remove this loader or those hits double.
// Welcome email/SMS cannot open a site path. shop.url is the primary domain, so a preview-theme
// submit still stamps the live shop link. ponytail: no per-market domain; upgrade is shop.domain per market.
function tlbResultLink(path, origin) {
  var raw = path || '/';
  if (/^https?:\/\//i.test(raw)) return raw;
  var base = String(origin || 'https://www.thelipbar.com').replace(/\/$/, '');
  return base + (raw.charAt(0) === '/' ? raw : '/' + raw);
}

var TLB_GA_ID = 'G-Z5GGD3K1WQ';
function tlbTrackQuiz(name, params) {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
  }
  if (!window.__tlbQuizGa) {
    window.__tlbQuizGa = true;
    window.gtag('js', new Date());
    window.gtag('config', TLB_GA_ID, { send_page_view: false });
    var gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + TLB_GA_ID;
    document.head.appendChild(gaScript);
  }
  window.dataLayer.push(Object.assign({ event: name }, params || {}));
  window.gtag('event', name, Object.assign({ send_to: TLB_GA_ID, transport_type: 'beacon' }, params || {}));
}

// Quiz UI. Reads TLB_QUESTIONS, picks the result page via TLBRouting, redirects there.
// Optional window.TLB_QUIZ_CONFIG = { resultsBase, assetBase, attentiveEndpoint, klaviyo: { publicKey, listId } } (set by the Shopify section).
(function () {
  var root = document.getElementById('tlb-quiz');
  if (!root) return;
  var CONFIG = window.TLB_QUIZ_CONFIG || {};
  var ASSET_BASE = CONFIG.assetBase || 'assets/';
  if (CONFIG.klaviyo && typeof KLAVIYO !== 'undefined') Object.assign(KLAVIYO, CONFIG.klaviyo);
  // Popup hand-off: /pages/find-your-lip-look?color=PINK_MAUVE pre-answers Q2 & skips that screen.
  var PRESET_COLOR = (function () {
    try {
      var c = new URLSearchParams(window.location.search).get('color');
      var q2 = TLB_QUESTIONS.filter(function (x) { return x.id === 'Q2'; })[0];
      return (q2 && q2.options.some(function (o) { return o.value === c; })) ? c : null;
    } catch (e) { return null; }
  })();
  function isSkipped(i) { return !!PRESET_COLOR && TLB_QUESTIONS[i] && TLB_QUESTIONS[i].id === 'Q2'; }
  function dispIndex(i) { return i - (PRESET_COLOR && i > 1 ? 1 : 0); }

  var TOTAL = TLB_QUESTIONS.length + 1 - (PRESET_COLOR ? 1 : 0); // questions + email step, minus a pre-answered Q2
  var state = { step: 0, answers: {} };
  if (PRESET_COLOR) state.answers.Q2 = PRESET_COLOR;
  var quizStartedFired = false;

  function trackEvent(name, params) {
    try {
      tlbTrackQuiz(name, params);
    } catch (e) {
      console.warn('quiz analytics failed', e);
    }
  }

  root.innerHTML =
    '<div class="tlb-screen tlb-screen--question" data-screen="question"></div>' +
    '<div class="tlb-screen tlb-screen--email" data-screen="email"></div>' +
    '<div class="tlb-screen tlb-screen--loading" data-screen="loading">' +
      '<div class="tlb-spinner">Loading</div><h2 class="tlb-title">Finding the perfect results for you...</h2></div>' +
    '<div class="tlb-footer"><button type="button" class="tlb-link tlb-back">\u2190 Back</button></div>';

  var screens = {
    question: root.querySelector('[data-screen=question]'),
    email: root.querySelector('[data-screen=email]'),
    loading: root.querySelector('[data-screen=loading]')
  };
  var footer = root.querySelector('.tlb-footer');
  footer.querySelector('.tlb-back').addEventListener('click', back);

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('is-active', k === name); });
    footer.classList.toggle('is-visible', name === 'question' && state.step > 0);
    root.scrollIntoView({ block: 'start' });
  }
  function progress(n) {
    var pct = Math.round(((n + 1) / TOTAL) * 100);
    return '<div class="tlb-progress" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100">' +
      '<div class="tlb-progress__fill" style="width:' + pct + '%"></div></div>';
  }

  function renderQuestion() {
    if (!quizStartedFired && state.step === 0) {
      quizStartedFired = true;
      trackEvent('quiz_started');
    }
    var q = TLB_QUESTIONS[state.step];
    var html = progress(dispIndex(state.step)) +
      '<p class="tlb-step"><b>Step ' + (dispIndex(state.step) + 1) + ' - </b>' + esc(q.step) + '</p>' +
      '<h2 class="tlb-title">' + esc(q.title) + '</h2>' +
      (q.subtitle ? '<p class="tlb-subtitle">' + esc(q.subtitle) + '</p>' : '') +
      '<div class="tlb-options" data-layout="' + q.layout + '" data-cols="' + q.cols + '">' +
      q.options.map(function (o) {
        var sel = state.answers[q.id] === o.value ? ' is-selected' : '';
        var img = o.image ? '<img class="tlb-opt__img" src="' + esc(ASSET_BASE + o.image) + '" alt="">' : '';
        return '<button type="button" class="tlb-opt tlb-opt--' + q.layout + sel + '" data-value="' + esc(o.value) + '">' +
          img + '<span class="tlb-opt__label">' + esc(o.label) + '</span></button>';
      }).join('') +
      '</div>' +
      (q.footnote ? '<p class="tlb-footnote">' + esc(q.footnote) + '</p>' : '');
    screens.question.innerHTML = html;
    screens.question.querySelectorAll('.tlb-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-value');
        state.answers[q.id] = val;
        btn.classList.add('is-selected');
        var opt = q.options.filter(function (x) { return x.value === val; })[0];
        trackEvent('quiz_question_answered', {
          question_id: q.id,
          question_step: q.step,
          question_title: q.title,
          answer_value: val,
          answer_label: opt ? opt.label : val
        });
        setTimeout(next, 150); // brief selected state, like the original auto-advance
      });
    });
    show('question');
  }

  function renderEmail() {
    screens.email.innerHTML = progress(TOTAL - 1) +
      '<button type="button" class="tlb-link tlb-back">\u2190 Back</button>' +
      '<h2 class="tlb-title">Last step!</h2>' +
      '<p class="tlb-subtitle">Enter your email address so we can send you updates.</p>' +
      '<form class="tlb-form" novalidate>' +
        '<label class="tlb-sr" for="tlb-email" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Email</label>' +
        '<input class="tlb-input" id="tlb-email" type="email" name="email" placeholder="Email Address" autocomplete="email">' +
        '<div class="tlb-error" data-error="email">Please enter a valid email address.</div>' +
        '<label for="tlb-phone" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Phone</label>' +
        '<input class="tlb-input" id="tlb-phone" type="tel" name="phone" placeholder="Phone Number (optional)" autocomplete="tel" inputmode="tel">' +
      '</form>' +
      '<p class="tlb-consent">By submitting this form, you agree to receive recurring automated marketing text messages (e.g. AI content, cart reminders) from The Lip Bar at the number you provide. Consent not a condition of purchase. We may share info with service providers per our Privacy Policy. Reply HELP for help &amp; STOP to cancel. Msg frequency varies. Msg &amp; data rates may apply. By submitting this form, you also agree to our <a href="https://attnl.tv/t/vTB/r/US" target="_blank" rel="noopener">Terms (incl. arbitration)</a> &amp; <a href="https://attnl.tv/p/vTB" target="_blank" rel="noopener">Privacy Policy</a>.</p>' +      '<button type="button" class="tlb-btn tlb-submit">Submit and View Results</button>' +
      '<p class="tlb-or">Or</p>' +
      '<button type="button" class="tlb-link tlb-skip">Skip and View Results</button>';

    var email = screens.email.querySelector('#tlb-email');
    var phone = screens.email.querySelector('#tlb-phone');
    var err = screens.email.querySelector('[data-error=email]');
    screens.email.querySelector('.tlb-back').addEventListener('click', back);
    screens.email.querySelector('.tlb-skip').addEventListener('click', function () {
      trackEvent('quiz_contact_submitted', { email_provided: false, phone_provided: false, skipped: true });
      finish(null, null);
    });
    screens.email.querySelector('.tlb-submit').addEventListener('click', function () {
      var v = email.value.trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
      email.classList.toggle('is-invalid', !ok);
      err.classList.toggle('is-visible', !ok);
      if (ok) {
        var p = phone.value.replace(/[^\d+]/g, '') || null;
        trackEvent('quiz_contact_submitted', { email_provided: true, phone_provided: !!p, skipped: false });
        finish(v, p);
      }
    });
    screens.email.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); screens.email.querySelector('.tlb-submit').click(); });
    show('email');
  }

  function render() { state.step < TLB_QUESTIONS.length ? renderQuestion() : renderEmail(); }
  function next() { state.step++; while (isSkipped(state.step)) state.step++; render(); }
  function back() { if (state.step > 0) { state.step--; while (state.step > 0 && isSkipped(state.step)) state.step--; render(); } }

  function tag(qid) {
    var q = TLB_QUESTIONS.filter(function (x) { return x.id === qid; })[0];
    var o = q && q.options.filter(function (x) { return x.value === state.answers[qid]; })[0];
    return o ? o.tag : null;
  }

  function finish(email, phone) {
    show('loading');
    var a = state.answers;
    var url = tlbResultLink(TLBRouting.resultUrl(a, CONFIG.resultsBase), CONFIG.shopOrigin);
    var complexionBucket = ['FAIR', 'LIGHT'].indexOf(a.Q5) >= 0 ? 'light' : 'deep';

    trackEvent('quiz_completed', {
      result_url: url,
      complexion: a.Q5,
      complexion_bucket: complexionBucket,
      color: tag('Q2'),
      feel: tag('Q3')
    });

    if (email) {
      attentiveSubmit(CONFIG.attentiveEndpoint, email, phone, {
        color: tag('Q2'),
        feel: tag('Q3'),
        complexion: a.Q5,
        complexion_bucket: complexionBucket,
        result_url: url,
        result_name: TLBRouting.resultName(url)
      });
    }

    var send = email ? klaviyoSubmit(email, phone, {
      quiz_persona: a.Q1, quiz_color_family: a.Q2, quiz_finish: a.Q3, quiz_objection: a.Q4,
      quiz_complexion: a.Q5, quiz_undertone: a.Q6, quiz_occasion: a.Q7,
      quiz_result_url: url, quiz_completed_at: new Date().toISOString()
    }) : Promise.resolve();
    var wait = new Promise(function (r) { setTimeout(r, 1500); });
    Promise.all([send, wait]).then(function () { window.location.href = url; });
  }

  render();
})();

if (typeof module !== 'undefined' && module.exports) module.exports = { tlbTrackQuiz: tlbTrackQuiz, tlbResultLink: tlbResultLink };